<!-- Decorative background blob -->
<div
  class="w-[240px] h-[480px] rounded-[50%] bg-action-secondary-30 blur-3xl absolute top-[10px] right-[-50px] z-[-1] rotate-[15deg]"
></div>

<!-- Mobile side-menu overlay (full-screen overlay inside the window) -->
@if (showSideMenu()) {
  <div class="absolute inset-0 z-10 flex flex-col bg-[#EDEFF7] dark:bg-background-main">
    <!-- Back header -->
    <div class="flex items-center px-4 py-3 border-b border-stroke-tertiary shrink-0">
      <button
        type="button"
        class="flex items-center gap-1 text-sm font-medium text-action-secondary dark:text-action-secondary-text"
        (click)="onCloseSideMenu()"
      >
        <svg-icon key="chevron-down-v-2-24" size="20" class="rotate-90" />
        <span>{{ 'ai-assistant.back' | translate }}</span>
      </button>
    </div>
    <!-- Sidebar content -->
    <app-ai-assistant-sidebar class="grow overflow-hidden" (navigated)="onCloseSideMenu()" />
  </div>
}

<div class="flex flex-col w-full h-full overflow-hidden">
  <!-- Header -->
  <div class="flex justify-between items-center px-4 pt-4 pb-2 shrink-0">
    <!-- Mobile: ··· (side-menu) button on the left -->
    @if (!('lg' | up)) {
      <button
        type="button"
        class="text-action-secondary dark:text-action-secondary-text text-lg leading-none tracking-widest px-1"
        aria-label="Menu"
        (click)="onOpenSideMenu()"
      >
        ···
      </button>
    } @else {
      <!-- Desktop: spacer so close button stays right-aligned -->
      <span></span>
    }

    <div class="flex items-center gap-4">
      <!-- Desktop only: expand to fullscreen -->
      @if ('lg' | up) {
        <svg-icon
          cdkDragHandle
          key="drag-32"
          size="24"
          class="cursor-grab text-action-secondary dark:text-action-secondary-text"
          aria-label="Drag AI assistant"
        />
        <button type="button" class="flex flex-col text-action-secondary dark:text-action-secondary-text" (click)="onExpand()">
          <svg-icon key="full-screen-24" size="24" />
        </button>
      }
      <!-- Close / collapse button -->
      <button type="button" class="flex flex-col text-action-secondary dark:text-action-secondary-text" (click)="onClose()">
        <svg-icon key="chevron-down-v-2-24" size="24" />
      </button>
    </div>
  </div>

  <div class="flex flex-col gap-3 text-action-secondary dark:text-action-secondary-text px-8">
    <svg-icon key="ai-52" size="56"></svg-icon>
    <span class="text-2xl font-medium">{{ 'ai-assistant.ask-optimo-ai' | translate }}</span>
  </div>

  <!-- Messages -->
  <app-ai-message-list
    [messages]="aiService.messages()"
    [isStreaming]="aiService.isStreaming()"
    [showTypingIndicator]="aiService.showTypingIndicator()"
    [showSuggestions]="true"
    [suggestions]="suggestionKeys"
    [messagesLoading]="aiService.messagesLoading()"
    (suggestionClicked)="onSuggestionClicked($event)"
    class="grow overflow-hidden"
  />

  @if (aiService.isNewChat()) {
    <app-ai-assistant-prompt-presets
      [promptPresets]="aiService.promptPresets()"
      [isLoading]="aiService.promptPresetsLoading()"
      [disabled]="aiService.composerDisabled()"
      (promptPresetSelected)="onPromptPresetSelected($event)"
      class="px-4 pb-4"
    />
  }

  <!-- Composer -->

  <div class="px-4 pb-4 shrink-0">
    <app-ai-composer
      [(value)]="composerValue"
      [disabled]="aiService.composerDisabled()"
      [uiContext]="aiService.uiContext()"
      (messageSent)="onMessageSent($event)"
    />
  </div>
</div>
